import { Component, OnInit, ElementRef,  Input, Output, EventEmitter } from '@angular/core';
import { LsSnackbarService } from '../../ls-snackbar/ls-snackbar.service';

@Component({
  selector: 'ls-image-upload2',
  templateUrl: './ls-image-upload2.component.html',
  styleUrls: ['./ls-image-upload2.component.css']
})
export class LsImageUpload2Component implements OnInit {


  allowExtensions = ['pdf', 'odt', 'doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'png'];
  blockExtensions = ['.jar', '.war', '.zip', '.rar', '.exe', '.tar', '.7z', '.iso', '.php', '.swf', '.html', '.js',]

  /**
   * Constructor
   * @param element 
   * @param dom 
   * @param uploadServices 
   */
  public constructor(private element: ElementRef, private snackBar: LsSnackbarService) { }
   /**
   * Src of image which is previously uploaded
   */
  @Input('backgroundColor') backgroundColor: string
  randomId: string = ""
  selectedImage: string

  /**
   * Src of image which is previously uploaded
   */
  @Input() uploadedImageSrc: string

  /**
   * Image File
   */
  fileImage;
  /**
 * Right side icon type
 */
  @Input('iconType') iconType

  /**
   * Max Image Upload Size
   */
  @Input('imageSize') imageSize
  /**
   * Width of Image
   */
  @Input('width') width
  /**
   * Height of Image
   */
  @Input('height') height
  /**
   * Image upload Event emitter
   */
  @Output("files") files = new EventEmitter();
  /**
 * delete
 */
  @Output("deleteImage") deleteImage = new EventEmitter();
    /**
 * delete
 */
@Output("customFn") customFn = new EventEmitter();
  /**
   * @ignore
   */
  resultValue;
  /**
   * Image to be render on the CANVAS
   */
  image: File;
  /**
   * 
   */
  ngOnInit() {
    this.randomId = "upload" + Math.floor(Math.random() * 10000)
  }
  /**
   * Click Event Emitter on the image upload reference
   */
  onClick() {
    this.element.nativeElement.querySelector("#lsimageupload2").click();


  }
  /**
   * 1. Selects the Image uploaded on the image uploader.
   * 2. Draws the Image on the canvas.
   * 3. If Button is hidden, display's the button.
   */
  getImage() {
    let files = this.element.nativeElement.querySelector('#lsimageupload2').files;
    let file = files[0];
    this.fileImage = file;
    if(file){
      this.selectedImage=null
      this.uploadedImageSrc=null
    }
    this.acceptedFiles(this.fileImage).then((resp) => {
      if (resp && resp == 'valid') {
      this.draw(this.fileImage);
        this.files.emit(this.fileImage)
      } else {
        this.snackBar.open('Invalid File Extension', '', 2000);
      }
    });
  }

  getHeight() {
    if(this.height){
      let mainHeight = this.height.split('p')
      return ((parseInt(mainHeight[0]) - 30) + 'px')
    }
    else{
      return '180px'
    }
  }
  getWidth() {
    if(this.width){
      let mainWidth = this.width.split('p')
      return ((parseInt(mainWidth[0]) - 2) + 'px')
    }
    else{
      return this.width
    }
  }

  /**
   * @ignore
   */
  ngAfterViewInit() {
  }
  /**
   * @ignore
   */
  b;
  /**
   * Draws the Image on the canvas according image ratio.
   * @param image 
   */
  draw(image) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.uploadedImageSrc = e.target.result
    }
    reader.readAsDataURL(image)
  }

  /**
   * Upload event handler
   */
  upload() {
    let files: Array<any> = new Array<any>();
    files.push(this.fileImage);
    this.files.emit(files)
  }



  // Block malicious files

  /**
     * blocks the not allowed extensions
     * @param fileName 
     */
  acceptedFiles(file: File) {
    return new Promise((resolve, reject) => {
      let isFileValid = false;
      if (file.name.split('.').length > 2) {
        return 'File Name is Invalid'
      }
      for (let i = 0; i < this.allowExtensions.length; i++) {
        if (file.name.split('.')[1] == this.allowExtensions[i] || file.type.includes(this.allowExtensions[i])) {
          // console.log("first", this.allowExtensions[i]);
          isFileValid = true;
          break;
        }
      }
      if (isFileValid) {
        this.internalFileValid(file).then((resp: any) => {
          if (resp) {
            resolve('valid');
          }
        }, err => {
          this.snackBar.open('Invalid File', '', 2000);
          resolve("Unsupported File Type.");
        })

      } else {
        this.snackBar.open('Invalid File', '', 2000);
        resolve("Unsupported File Type.");
      }

    })
  }

  delete() {
    this.selectedImage = null
    this.uploadedImageSrc = null
    this.deleteImage.emit(true)

  }
  customFunction() {
this.customFn.emit('true')
  }

  internalFileValid(file) {
    return new Promise((resolve, reject) => {
      let blob: File = file
      let header = '';
      let fileReader = new FileReader

      fileReader.onloadend = () => {
        let arr = new Uint8Array(fileReader.result as Iterable<any>).subarray(0, 12);
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }
        let buffer = header.toLowerCase();
        console.log("complete header string", buffer);

        // pdf, png, jpg/jpeg, doc/xls, docx/xlsx~jar~zip
        // || buffer.substring(0, 8) == '504b0304'
        if (buffer.substring(0, 8) == '89504e47' || buffer.substring(0, 4) == 'ffd8') {
          resolve(true);
        } else {
          reject(false)
        }
      }
      fileReader.readAsArrayBuffer(blob)
    })
  }





}
